<script setup lang="ts">
import type { TasksKanbanCardCustomerProps } from '../types/interfaces'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser } from '@fortawesome/pro-regular-svg-icons'

import { AppBadge, BadgeCustomerBrand } from '@shared/ui/badges'
import { AppText, AppTextLink } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'
import { IconContainer } from '@shared/ui/other'

import { useTasksKanbanCardCustomer } from '../composables/tasks-kanban-card-customer.hook'

defineOptions({
  name: 'TasksKanbanCardCustomer',
})

const props = withDefaults(defineProps<TasksKanbanCardCustomerProps>(), {
  customerName: null,
  kidName: null,
  discipline: null,
  disciplineUrl: null,
  relatedToType: null,
  subscriptionId: null,
  subscriptionUrl: null,
  isGo: false,
  customerBrand: null,
})

const {
  refCustomerName,
  refKidName,
  refDisciplineLabel,
  refSubscriptionLabel,
  refSecondLineText,
  refIsSubscription,
  refHasSecondLine,
} = useTasksKanbanCardCustomer({ props })
</script>

<template>
  <div
    v-if="refCustomerName || refHasSecondLine"
    class="task-card__customer"
  >
    <IconContainer class="small">
      <FontAwesomeIcon :icon="faUser" />
    </IconContainer>
    <AppBadge
      v-if="isGo"
      class="task-card__customer-go"
      color="emerald"
      text="Goal"
    />
    <BadgeCustomerBrand
      class="task-card__customer-brand"
      :brand="customerBrand"
      view="icon"
    />
    <div class="task-card__customer-body">
      <div
        v-if="refCustomerName"
        class="task-card__customer-name"
      >
        <AppTooltip
          :text="refCustomerName"
          placement="top"
          size="small"
        >
          <AppText
            name="body2"
            color="slate-700"
          >
            {{ refCustomerName }}
          </AppText>
        </AppTooltip>
      </div>

      <div
        v-if="refHasSecondLine"
        class="task-card__customer-additional"
      >
        <AppTooltip
          :text="refSecondLineText"
          placement="top"
          size="small"
        >
          <AppTextLink
            v-if="refIsSubscription && subscriptionUrl"
            color="blue-500"
            name="body2"
            :href="subscriptionUrl"
            target="_blank"
          >
            {{ refSubscriptionLabel }}
          </AppTextLink>
          <AppText
            v-else-if="refIsSubscription"
            name="body2"
            color="slate-500"
          >
            {{ refSubscriptionLabel }}
          </AppText>
          <span
            v-else
            class="task-card__customer-additional-inner"
          >
            <AppText
              v-if="refKidName"
              name="body2"
              color="slate-500"
            >
              {{ refKidName }}
            </AppText>
            <template v-if="refDisciplineLabel">
              <AppText
                v-if="refKidName"
                name="body2"
                color="slate-500"
              >
                -
              </AppText>
              <AppTextLink
                v-if="disciplineUrl"
                color="blue-500"
                name="body2"
                :href="disciplineUrl"
                target="_blank"
              >
                {{ refDisciplineLabel }}
              </AppTextLink>
              <AppText
                v-else
                name="body2"
                color="slate-500"
              >
                {{ refDisciplineLabel }}
              </AppText>
            </template>
          </span>
        </AppTooltip>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_tasks-kanban-card-customer.scss" />
